var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _handleResize, _previousScrollY, _DialogComponent_instances, handleClick_fn, handleKeyDown_fn;
import { Component } from "@theme/component";
import { debounce, isClickedOutside, lockScroll, onAnimationEnd, unlockScroll } from "@theme/utilities";
import { getScrollTop, scrollTo } from "@theme/scroll-container";
class DialogComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _DialogComponent_instances);
    __publicField(this, "requiredRefs", ["dialog"]);
    __privateAdd(this, _handleResize, debounce(() => {
      const { minWidth, maxWidth } = this;
      if (!minWidth && !maxWidth) return;
      const windowWidth = window.innerWidth;
      if (windowWidth < minWidth || windowWidth > maxWidth) {
        this.closeDialog();
      }
    }, 50));
    __privateAdd(this, _previousScrollY, 0);
    /**
     * Closes the dialog.
     */
    __publicField(this, "closeDialog", async () => {
      const { dialog } = this.refs;
      if (!dialog.open) return;
      this.removeEventListener("click", __privateMethod(this, _DialogComponent_instances, handleClick_fn));
      this.removeEventListener("keydown", __privateMethod(this, _DialogComponent_instances, handleKeyDown_fn));
      dialog.style.animation = "none";
      void dialog.offsetWidth;
      dialog.classList.add("dialog-closing");
      dialog.style.animation = "";
      await onAnimationEnd(dialog, void 0, {
        subtree: false
      });
      unlockScroll(dialog);
      scrollTo({ top: __privateGet(this, _previousScrollY), behavior: "instant" });
      dialog.close();
      dialog.classList.remove("dialog-closing");
      this.dispatchEvent(new DialogCloseEvent());
    });
    /**
     * Toggles the dialog.
     */
    __publicField(this, "toggleDialog", () => {
      if (this.refs.dialog.open) {
        this.closeDialog();
      } else {
        this.showDialog();
      }
    });
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.minWidth || this.maxWidth) {
      window.addEventListener("resize", __privateGet(this, _handleResize));
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.minWidth || this.maxWidth) {
      window.removeEventListener("resize", __privateGet(this, _handleResize));
    }
    unlockScroll(this.refs.dialog);
  }
  /**
   * Shows the dialog.
   */
  showDialog() {
    const { dialog } = this.refs;
    if (dialog.open) return;
    __privateSet(this, _previousScrollY, getScrollTop());
    requestAnimationFrame(() => {
      lockScroll(dialog);
      dialog.showModal();
      this.dispatchEvent(new DialogOpenEvent());
      this.addEventListener("click", __privateMethod(this, _DialogComponent_instances, handleClick_fn));
      this.addEventListener("keydown", __privateMethod(this, _DialogComponent_instances, handleKeyDown_fn));
    });
  }
  /**
   * Gets the minimum width of the dialog.
   *
   * @returns {number} The minimum width of the dialog.
   */
  get minWidth() {
    return Number(this.getAttribute("dialog-active-min-width"));
  }
  /**
   * Gets the maximum width of the dialog.
   *
   * @returns {number} The maximum width of the dialog.
   */
  get maxWidth() {
    return Number(this.getAttribute("dialog-active-max-width"));
  }
}
_handleResize = new WeakMap();
_previousScrollY = new WeakMap();
_DialogComponent_instances = new WeakSet();
/**
 * Closes the dialog when the user clicks outside of it.
 *
 * @param {MouseEvent} event - The mouse event.
 */
handleClick_fn = function(event) {
  const { dialog } = this.refs;
  if (isClickedOutside(event, dialog)) {
    this.closeDialog();
  }
};
/**
 * Closes the dialog when the user presses the escape key.
 *
 * @param {KeyboardEvent} event - The keyboard event.
 */
handleKeyDown_fn = function(event) {
  if (event.key !== "Escape") return;
  event.preventDefault();
  this.closeDialog();
};
if (!customElements.get("dialog-component")) customElements.define("dialog-component", DialogComponent);
const _DialogOpenEvent = class _DialogOpenEvent extends CustomEvent {
  constructor() {
    super(_DialogOpenEvent.eventName);
  }
};
__publicField(_DialogOpenEvent, "eventName", "dialog:open");
let DialogOpenEvent = _DialogOpenEvent;
const _DialogCloseEvent = class _DialogCloseEvent extends CustomEvent {
  constructor() {
    super(_DialogCloseEvent.eventName);
  }
};
__publicField(_DialogCloseEvent, "eventName", "dialog:close");
let DialogCloseEvent = _DialogCloseEvent;
document.addEventListener(
  "toggle",
  (event) => {
    if (event.target instanceof HTMLDetailsElement) {
      if (event.target.hasAttribute("scroll-lock")) {
        const { open } = event.target;
        if (open) {
          lockScroll(event.target);
        } else {
          unlockScroll(event.target);
        }
      }
    }
  },
  { capture: true }
);
export {
  DialogCloseEvent,
  DialogComponent,
  DialogOpenEvent
};
